<template>
    <section class="search-nationwide-prompt">
        <div class="p-y-2">
            <h2 class="f2 text-bold m-y-s">{{ molang('search.nationwide.title') }}</h2>
            <p class="f5 text-gray">{{ molang('search.nationwide.body') }}</p>
        </div>
        <hr />
    </section>
</template>

<script>
export default {
    name: 'searchNationwidePrompt',
};
</script>

<style lang="scss">
.search-nationwide-prompt { margin: calc(var(--section-gap-y) / 2) auto; }
</style>
